import { Mail } from "lucide-react";
import { Button } from "@/components/ui/button";

type MaintenanceProps = {
  platformName?: string;
  supportEmail?: string;
  maintenanceMessage?: string;
};

const DEFAULT_MESSAGE =
  "We're currently performing scheduled maintenance. Please check back soon.";

export default function Maintenance({
  platformName = "ProteasAI",
  supportEmail = "support@proteasai.com",
  maintenanceMessage = DEFAULT_MESSAGE,
}: MaintenanceProps) {
  return (
    <div className="min-h-screen bg-background">
      <div className="mx-auto flex min-h-screen max-w-3xl flex-col items-center justify-center gap-8 px-6 py-16 text-center">
        <div className="space-y-3">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-muted-foreground">
            {platformName}
          </p>
          <h1 className="text-3xl font-semibold text-foreground sm:text-4xl">
            We&apos;ll be right back
          </h1>
          <p className="text-base text-muted-foreground sm:text-lg">
            {maintenanceMessage}
          </p>
        </div>
        <div className="space-y-3">
          <p className="text-sm text-muted-foreground">
            Need help right away? Reach our team at{" "}
            <span className="font-medium text-foreground">{supportEmail}</span>.
          </p>
          <Button asChild>
            <a href={`mailto:${supportEmail}`} className="inline-flex items-center gap-2">
              <Mail className="h-4 w-4" />
              Contact support
            </a>
          </Button>
        </div>
      </div>
    </div>
  );
}
